export default __webpack_public_path__ + "static/media/component_ultrasonic_sensor.81858f41.png";